<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch7">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch7.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-7"><em class="italic">KABBOOOM!</em></a></p><a id="pg-7">
<p class="para" style="text-indent: 5%;">You zip out the bottom of the chute just as the plant blows up. A moment later you are surrounded by cheering rebels.</p>
<p class="para" style="text-indent: 5%;">“You did it!” Jarmal slaps you on the back. “The war isn’t over yet, but I am sure that we will win.”</p>
<p class="para" style="text-indent: 5%;">“Now help me find my brother,” you say.</p>
<p class="para" style="text-indent: 5%;">“I’ve located him on the space station,” Jarmal tells you. “Some of the rebels sent him there for safety.”</p>
<p class="para" style="text-indent: 5%;">“I have to go there,” you say.</p>
<p class="para" style="text-indent: 5%;">Jarmal nods and leads you to a small space shuttle. “This will take you there,” he tells you. “Good luck.”</p>
<p class="para" style="text-indent: 5%;">You say good-bye, then strap yourself into the automated ship.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-7"><em class="italic">Blast off to </em></a><span href="#/e9780545841016_ch098" title="Link target outside of Sample"><em class="italic">PAGE 98</em></span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841016_ch007.vue?741298ec